import React from 'react';
import { ClipboardCheckIcon, ClipboardListIcon, GitBranchIcon, HomeIcon, LineChartIcon, ListChecksIcon, TableIcon, TargetIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCTA } from './SectionCTA';
import { toolkit } from '../data/content';
const icons = [GitBranchIcon, TableIcon, ListChecksIcon, TargetIcon, LineChartIcon, ClipboardListIcon, HomeIcon, ClipboardCheckIcon];
export function Toolkit() {
  return <section className="w-full bg-brand-900 px-5 py-16 md:py-24" data-id="element-334" data-mp="5wn2uctutopb">
      <div className="mx-auto max-w-5xl" data-id="element-335" data-mp="5wdfyy43vxnu">
        <SectionHeading dark eyebrow="Also Included: The Complete Sensory Intervention Planning Toolkit™" title="35+ Practical Tools to Help You Put the Roadmap Into Practice" subtitle="Alongside the six volumes, you'll receive printable educational resources designed to support structured intervention planning." data-id="element-336" data-mp="kufj57786h4k" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-337" data-mp="2ho8u7o00i3nk">
          {toolkit.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.title} className="flex gap-4 rounded-3xl bg-white p-5 sm:p-6" data-id="element-338" data-mp="242u5x4p4goql" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-100 text-brand-700" data-id="element-339" data-mp="290n8zov4p2mn">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-340" data-mp="2dt6mklttfxrg" />
                </span>
                <div data-id="element-341" data-mp="2ipndtowbas8r">
                  <h3 className="text-lg font-extrabold leading-snug text-brand-950" data-id="element-342" data-mp="2iqf7gu6cmfwe">{t.title}</h3>
                  <p className="mt-1.5 text-base leading-relaxed text-brand-900/75" data-id="element-343" data-mp="2nnylbsz4wqnt">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-344" data-mp="2wpew41tv2usk">
          <p className="text-balance text-2xl font-extrabold text-white sm:text-3xl" data-id="element-345" data-mp="xdlufrw4p19i">
            Imagine Having a Practical Planning Reference Ready Whenever You Need It.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-brand-100" data-id="element-346" data-mp="12e9t8zqlmmea">
            Instead of wondering how to organize your next intervention plan, you'll have structured worksheets to help you
            identify priorities, explore options, document decisions, and plan follow-up.
          </p>
        </div>

        <SectionCTA dark label="Get the Complete Intervention Toolkit™" data-id="element-347" data-mp="29p7lorawbdks" />
      </div>
    </section>;
}